<template>
  <div>
    <b-card>
      <div v-if="loading">
        <b-spinner
          variant="primary"
          style="width: 3rem; height: 3rem"
          label="Large Spinner"
        ></b-spinner>
      </div>

      <div class="row" v-if="!loading">
        <div class="col">
          <h4 v-if="propertyLease.property">
            {{ propertyLease.property.title }}
          </h4>
        </div>
        <div class="col-auto">
          <b-button
            v-if="
              propertyLease.is_terminated == 0 && propertyLease.is_ended == 0
            "
            class="btn-danger float-right"
            @click="confirmTerminate(propertyLease.id)"
          >
            Terminate
          </b-button>

          <router-link
            v-if="
              propertyLease.is_terminated == 0 && propertyLease.is_ended == 0
            "
            v-b-tooltip.hover
            title="edit"
            :to="{ name: 'leases-edit', params: { id: propertyLease.id } }"
            class="btn btn-info float-right mr-1"
          >
            <i class="lni lni-pencil mr-0"></i>
          </router-link>

          <a
            v-b-tooltip.hover
            title="Print"
            :href="
              '/pdf/reports/lease/' +
              id +
              '/report?cid=' +
              propertyLease.company_id
            "
            class="btn btn-primary float-right mr-1"
            target="_blank"
          >
            <i class="lni lni-printer mr-0"></i>
          </a>
        </div>
      </div>

      <div class="row mt-2" v-if="!loading">
        <b-col>
          <b-tabs v-model="tabIndex">
            <b-tab title="Details">
              <table class="table mt-3">
                <table-row label="Tenant" :noBorder="true">
                  <router-link
                    v-if="propertyLease.tenant"
                    v-b-tooltip.hover
                    title="view"
                    :to="{
                      name: 'tenants-show',
                      params: { id: propertyLease.tenant.id },
                    }"
                    class="text-primary"
                  >
                    {{ propertyLease.tenant.name }}
                  </router-link>
                </table-row>

                <table-row label="Property">
                  <router-link
                    v-if="propertyLease.property"
                    v-b-tooltip.hover
                    title="view"
                    :to="{
                      name: 'properties-show',
                      params: { id: propertyLease.property.id },
                    }"
                    class="text-primary"
                  >
                    {{ propertyLease.property.title }}
                  </router-link>
                </table-row>

                <table-row label="Status">
                  {{ propertyLease.status }}
                </table-row>

                <table-row label="Type">
                  {{ propertyLease.type }}
                </table-row>

                <table-row label="Invoice Frequency">
                  {{ propertyLease.invoice_frequency }}
                </table-row>

                <table-row
                  label="Invoice Day"
                  v-if="
                    propertyLease.auto_generate == 1 &&
                    propertyLease.invoice_frequency != 'Daily'
                  "
                >
                  {{ propertyLease.invoice_day }}
                </table-row>

                <table-row label="Invoice Description">
                  {{ propertyLease.invoice_description }}
                </table-row>

                <table-row
                  label="Invoice Amount"
                  v-if="propertyLease.auto_generate == 1"
                >
                  {{ propertyLease.invoice_amount | currency }}
                </table-row>

                <table-row
                  label="Auto Generate"
                  v-if="propertyLease.auto_generate == 1"
                >
                  Yes
                </table-row>

                <table-row
                  label="Email to client"
                  v-if="propertyLease.auto_generate == 1"
                >
                  <span v-if="propertyLease.auto_email == 1">Yes</span>
                  <span v-if="propertyLease.auto_email == 0">No</span>
                </table-row>

                <table-row
                  label="SMS to client"
                  v-if="propertyLease.auto_generate == 1"
                >
                  <span v-if="propertyLease.auto_sms == 1">Yes</span>
                  <span v-if="propertyLease.auto_sms == 0">No</span>
                </table-row>

                <table-row label="From">
                  {{
                    moment(new Date(propertyLease.from)).format("DD MMM YYYY")
                  }}
                </table-row>

                <table-row label="To" v-if="propertyLease.type == 'fixed'">
                  {{ moment(new Date(propertyLease.to)).format("DD MMM YYYY") }}
                </table-row>

                <table-row
                  label="Terminated"
                  v-if="propertyLease.is_terminated"
                >
                  <span class="text-danger">
                    {{
                      moment(new Date(propertyLease.termination_date)).format(
                        "DD MMM YYYY"
                      )
                    }}
                  </span>
                </table-row>

                <table-row label="Deposit Amount">
                  {{ propertyLease.deposit_amount | currency }}
                </table-row>

                <table-row label="Creator" v-if="propertyLease.user">
                  {{ propertyLease.user.name }}
                </table-row>

                <table-row icon="lni-database" :noBorder="true" />

                <table-row label="Id">
                  {{ propertyLease.id }}
                </table-row>

                <table-row label="Created">
                  {{
                    moment(new Date(propertyLease.created_at)).format(
                      "DD MMM YYYY, HH:mm:ss"
                    )
                  }}
                </table-row>
                <table-row label="Updated">
                  {{
                    moment(new Date(propertyLease.updated_at)).format(
                      "DD MMM YYYY, HH:mm:ss"
                    )
                  }}
                </table-row>
              </table>
            </b-tab>

            <b-tab title="Comments" class="pt-3">
              <div
                v-for="comment in propertyLease.property_lease_comments"
                :key="comment.id"
                class="card border-bottom p-2 mb-1"
              >
                <p class="nl2br">
                  {{ comment.comment }}
                </p>

                <div class="row">
                  <div class="col-auto">
                    <b-avatar v-if="!comment.user.image"></b-avatar>
                    <b-avatar
                      v-if="comment.user.image"
                      :src="comment.user.image"
                    ></b-avatar>
                  </div>
                  <div class="col">
                    <h6 class="mb-0 mt-1 font-weight-bold">
                      {{ comment.user.name }}
                    </h6>
                    <small class="text-muted">
                      <i class="lni lni-calendar"></i>
                      {{
                        moment(new Date(comment.created_at)).format(
                          "DD MMM YYYY, HH:mm:ss"
                        )
                      }}

                      |

                      {{
                        moment
                          .duration(
                            moment(Date.now()).diff(
                              moment(new Date(comment.created_at)),
                              "seconds"
                            ),
                            "seconds"
                          )
                          .format("Y [year] D [day], H [hour &] m [min]")
                      }}
                      ago
                    </small>
                  </div>
                </div>
              </div>

              <form-base
                :submit-status="submitStatus"
                action="Comment"
                :errors="errors"
                :loading="loading"
                v-on:handleSubmit="createComment"
              >
                <template v-slot:fields>
                  <form-group label="Comment" :required="true">
                    <textarea-autosize
                      class="form-control"
                      v-model="newComment"
                    />
                  </form-group>
                </template>
              </form-base>
            </b-tab>

            <b-tab title="Files" class="pt-3">
              <table class="table">
                <tr
                  v-for="file in propertyLease.property_lease_files"
                  :key="file.id"
                >
                  <td>
                    <a :href="file.url" target="new">
                      {{ file.description }}<br />
                    </a>
                  </td>
                  <td>{{ file.size / 1024 }}kb</td>
                  <td class="text-right text-muted">
                    {{
                      moment(new Date(file.created_at)).format(
                        "DD MMM YYYY, HH:mm:ss"
                      )
                    }}
                  </td>
                  <td class="text-right">
                    <i
                      class="lni lni-trash text-danger pointer table-action-icon"
                      @click="fileDeleteConfirm(file.id)"
                    ></i>
                  </td>
                </tr>
              </table>

              <div class="bg-light p-3 my-2">
                <form-group label="Add Files">
                  <file-upload
                    :key="fileComponentKey"
                    @files-uploaded="
                      selectedPropertyLeaseFiles = $event;
                      fileUploading = false;
                    "
                    @files-uploaded-started="fileUploading = true"
                    :multiple="true"
                  />
                  <small class="text-muted font-size-11"
                    >*Max file size is 16MB</small
                  >
                </form-group>
                <b-button
                  class="float-right"
                  @click="saveFiles"
                  variant="primary"
                  size="sm"
                  v-if="selectedPropertyLeaseFiles.length > 0"
                  >Save Files</b-button
                >

                <div style="clear: both"></div>
              </div>

              <b-skeleton-img v-if="FileLoading"></b-skeleton-img>

              <div></div>
            </b-tab>

            <b-tab class="pt-3" title="Images">
              <b-skeleton-img v-if="ImageLoading"></b-skeleton-img>

              <v-lazy-image
                @intersect="ImageLoading = true"
                @load="ImageLoading = false"
                v-if="selectedImage != null"
                :src="selectedImage"
                class="img-fluid border"
              />
              <div></div>

              <div
                class="border d-inline-block p-1 m-1"
                v-for="image in propertyLease.property_lease_images"
                :key="image.id"
              >
                <a href="#" @click="selectedImage = image.large">
                  <v-lazy-image :src="image.small" class="maxHeight100" />
                </a>
                <i
                  class="lni lni-trash text-danger pointer table-action-icon position-absolute ml-n4"
                  @click="imageDeleteConfirm(image.id, propertyLease.id)"
                ></i>
              </div>

              <div v-if="loading">
                <b-spinner
                  variant="primary"
                  style="width: 1rem; height: 1rem"
                  label="Large Spinner"
                ></b-spinner>
              </div>

              <div class="bg-light p-3 my-2">
                <form-group label="Add Images">
                  <image-upload
                    :key="imageComponentKey"
                    @files-uploaded="
                      selectedImages = $event;
                      imageUploading = false;
                    "
                    @files-uploaded-started="imageUploading = true"
                    :multiple="true"
                    :imageCrop="false"
                    acceptedTypes="image/*"
                  />
                  <small class="text-muted font-size-11"
                    >*Max file size is 16MB</small
                  >
                </form-group>
                <b-button
                  class="float-right"
                  @click="saveImages"
                  variant="primary"
                  size="sm"
                  v-if="selectedImages.length > 0"
                  >Save Images</b-button
                >
                <div style="clear: both"></div>
              </div>
            </b-tab>

            <b-tab title="Invoices">
              <invoices :propertyLeaseId="id"></invoices>
            </b-tab>
          </b-tabs>
        </b-col>
      </div>
    </b-card>
  </div>
</template>

<script>
import propertyLeaseRepo from "@/api/repos/propertyLeaseRepo";
import tableRow from "@/components/common/TableRow";
import fileUpload from "@/components/common/FileUpload";
import formGroup from "@/components/common/FormGroup";
import formBase from "@/components/common/FormBase";
import invoices from "@/views/modules/leases/invoices";
import imageUpload from "@/components/common/ImageUpload";

export default {
  props: ["id"],

  components: {
    tableRow,
    fileUpload,
    formGroup,
    invoices,
    formBase,
    imageUpload,
  },

  mounted() {
    this.getPropertyLease();
  },

  data() {
    return {
      newComment: null,
      tabIndex: 0,
      loading: false,
      propertyLease: {},
      selectedPropertyLeaseFiles: [],
      fileComponentKey: 1,
      fileUploading: false,
      FileLoading: false,
      errors: null,
      submitStatus: null,
      selectedImage: null,
      selectedImages: [],
      imageComponentKey: 1,
      imageUploading: false,
      ImageLoading: false,
    };
  },

  methods: {
    async getPropertyLease() {
      try {
        this.loading = true;
        let { data } = await propertyLeaseRepo.get(this.id);
        this.propertyLease = data.lease;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    confirmTerminate(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to terminate the lease.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.terminateLease(id) : false))
        .catch((error) => console.log(error));
    },

    async terminateLease(id) {
      this.loading = true;
      try {
        await propertyLeaseRepo.terminate(id);
        this.$root.$bvToast.toast("Terminated", {
          title: "Terminated",
          autoHideDelay: 3000,
          variant: "success",
        });
        this.getPropertyLease();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async createComment() {
      this.loading = true;
      this.submitStatus = "PENDING";

      if (this.newComment == null) {
        alert("Enter comment");
        this.submitStatus = "ERROR";
        this.loading = false;
      } else {
        try {
          await propertyLeaseRepo.createComment({
            comment: this.newComment,
            property_lease_id: this.id,
          });
          this.getPropertyLease();
          this.tabIndex = 1;
          this.newComment = null;
          this;
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          } else {
            this.$root.$bvToast.toast("Something Went Wrong", {
              title: error.response.data.message,
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },

    async saveFiles() {
      if (this.fileUploading) {
        this.$root.$bvToast.toast("Files Uploading", {
          title: "Please wait for files to upload",
          autoHideDelay: 2000,
          variant: "warning",
        });
        return false;
      } else {
        try {
          await propertyLeaseRepo.files(this.id, {
            lease_files: this.selectedPropertyLeaseFiles.split(","),
          });
          this.$root.$bvToast.toast("Uploaded", {
            title: "Uploaded",
            autoHideDelay: 3000,
            variant: "success",
          });
          this.selectedPropertyLeaseFiles = [];
          this.fileComponentKey++;

          this.tabIndex = 2;
          this.getPropertyLease();
        } catch (ex) {
          this.$root.$bvToast.toast("Whoops", {
            title: "Something went wrong",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      }
    },

    async deleteFile(id) {
      this.loading = true;
      try {
        await propertyLeaseRepo.fileDelete(this.id, id);
        this.getPropertyLease();
        this.tabIndex = 2;
      } catch (error) {
        this.$root.$bvToast.toast("Whoops", {
          title: "Something went wrong",
          autoHideDelay: 3000,
          variant: "danger",
        });
      } finally {
        this.loading = false;
      }
    },
    fileDeleteConfirm(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the file.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteFile(id) : false))
        .catch((error) => console.log(error));
    },

    async deleteImage(id, leaseId) {
      this.loading = true;
      try {
        await propertyLeaseRepo.imageDelete(leaseId, id);
        await this.getPropertyLease();
        this.tabIndex = 3;
        this.selectedImage = null;
      } catch (error) {
        this.$root.$bvToast.toast("Whoops", {
          title: "Something went wrong",
          autoHideDelay: 3000,
          variant: "danger",
        });
      } finally {
        this.loading = false;
      }
    },
    imageDeleteConfirm(id, leaseId) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the image.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteImage(id, leaseId) : false))
        .catch((error) => console.log(error));
    },
    async saveImages() {
      if (this.imageUploading) {
        this.$root.$bvToast.toast("Images Uploading", {
          title: "Please wait for files to upload",
          autoHideDelay: 2000,
          variant: "warning",
        });
        return false;
      } else {
        try {
          await propertyLeaseRepo.images(this.id, {
            property_lease_images: this.selectedImages.split(","),
          });
          this.$root.$bvToast.toast("Uploaded", {
            title: "Uploaded",
            autoHideDelay: 3000,
            variant: "success",
          });
          this.selectedImages = [];
          this.imageComponentKey++;
          await this.getPropertyLease();
          this.tabIndex = 3;
        } catch (ex) {
          this.$root.$bvToast.toast("Whoops", {
            title: "Something went wrong",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      }
    },
  },
};
</script>
